import { parseMimesToExtensions } from '../parseMimesToExtensions';

const validUnsupportedFileExtensions = ['heic', 'heif'];

export const isSupportedByBrowser = (image: File) => {
    if (image.type) {
        // The following ensures browser can load image into memory
        // since image.type is based on OS
        const extensions = parseMimesToExtensions(image.type);
        return !extensions.some(e => validUnsupportedFileExtensions.includes(e));
    } else {
        return false;
    }
};

export const isValidButUnsupportedByBrowser = (image: File) => {
    return validUnsupportedFileExtensions.some(e => image.name.endsWith(e));
};